import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "src/components/app/Button";
import Header from "src/components/app/layout/Header";
import Input from "src/components/app/Input";
import Layout from "src/components/app/layout/Layout";
import moment from "moment";
import * as journeyActions from "src/redux/slices/journeySlice";
import { useAppDispatch } from "src/redux/hooks";
import { toast } from "sonner";

const RescheduleCycleScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params = useParams();
  const currentCycle = location.state?.cycle;
  const supportProgramKey = params["support-program-key"];
  const [rescheduleDate, setRescheduleDate] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("");

  const getOrdinal = (n: number): string => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  };

  const handleDateChange = (date: any) => {
    if (
      moment(date.target.value).isBefore(
        moment(currentCycle?.rescheduled_date)
      ) ||
      moment(date.target.value).isSame(moment(currentCycle?.rescheduled_date))
    ) {
      setError(true);
      setHelperText("Please select a date after the current cycle date");
      return;
    }

    if (
      moment(date.target.value).isAfter(moment(currentCycle?.rescheduled_date))
    ) {
      setError(false);
      setHelperText("");
      setRescheduleDate(date.target.value);
      return;
    }
  };

  const handleRescheduleCycle = () => {
    console.log("handleRescheduleCycle", rescheduleDate);
    const payload = {
      patient_visit_id: currentCycle.patient_visit_id,
      reschedule_date: moment(rescheduleDate).format("YYYY-MM-DD"),
      updated_by: currentCycle.patient_id,
    };
    const extra = {
      ...currentCycle,
      new_date: moment(rescheduleDate).format("YYYY-MM-DD"),
    };

    // console.log("extra", extra);

    new Promise((resolve, reject) => {
      dispatch(
        journeyActions.rescheduleCycleRequest({
          resolve,
          reject,
          payload,
          extra,
        })
      );
    })
      .then((res) => {
        toast.success("Cycle rescheduled successfully");
        navigate(-1);
      })
      .catch((error) => {
        console.error("error", error);
        toast.error("Something went wrong");
      });
  };

  // console.log("cycle", currentCycle);
  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <Header
        title={`Reschedule ${getOrdinal(currentCycle?.visit_cycle)} Cycle`}
        titlePosition="center"
        showBackButton={true}
        onBackClick={() => {
          navigate(-1);
        }}
      />
      <div className="relative w-full h-full px-4 py-4 bg-white">
        <div>
          <h6 className="text-sm font-bold mb-4">
            When will you go for your next cycle?
          </h6>
        </div>
        <div className="w-full p-4 bg-gray-50 rounded-lg">
          <div className="w-full flex flex-col gap-3">
            <Input
              label="Select Reschedule Date"
              name="rescheduleDate"
              type="date"
              placeholder="Select Reschedule Date"
              onChange={(value) => {
                handleDateChange(value);
              }}
              error={error}
              helperText={helperText}
              fullWidth
            />
            <Button onClick={handleRescheduleCycle}>Reschedule Cycle</Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RescheduleCycleScreen;
